// ui-library
import { boxShadow, color } from '@upstox/upstox-ui';
import { fonts } from '@upstox/upstox-ui/theme/light/fonts';
// service
import PlatformService from 'modules/Platform';

export const modalContainer: CSSFunction = () => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  fontFamily: fonts.tvFont,
});

export const modalDialog: CSSFunction = ({ theme }) => ({
  zIndex: 2,
  background: color(theme, theme.modals.backgroundBackdrop),
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

export const base: CSSFunction = ({ theme }) => ({
  zIndex: 3,
  backgroundColor: color(theme, theme.colors.background.default4),
  boxShadow: boxShadow(theme, theme.modals.boxShadow),
  margin: 'auto',
  maxHeight: '60%',
  width: PlatformService.isMobile ? '90%' : '420px',
  position: 'absolute',
  lineHeight: '20px',
  transform: 'translate(0, 0)',
  top: '15%',
  borderRadius: 8,
});

export const modalHeader: CSSFunction = ({ theme }) => ({
  padding: 10,
  borderBottom: `${color(theme, theme.colors.ui3)} solid 1px`,
});

export const modalBody: CSSFunction = ({ theme }) => ({
  padding: 24,
  paddingBottom: 16,
  overflow: 'scroll',
  borderBottom: `${color(theme, theme.colors.ui3)} solid 1px`,
  '::-webkit-scrollbar': {
    '-webkit-appearance': 'none',
    width: 6,
    height: 6,
  },
  '::-webkit-scrollbar-thumb': {
    borderRadius: '4px',
    backgroundColor: color(theme, 'ui8'),
    boxShadow: '0 0 1px rgba(255,255,255,0.5)',
  },
  '::-webkit-scrollbar-corner': {
    backgroundColor: 'inherit',
  },
});

export const modalFooter: CSSFunction = () => ({
  padding: '16px 24px',
});

export const contentContainer: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  height: '100%',
});

export const notificationImg: CSSFunction = () => ({
  borderRadius: 8,
  maxHeight: 500,
  width: '100%',
});
